// Map markers for cab tracking, in the zingbus purple used by the SHP map
// (images/current-location.svg).
export const BRAND = "#7b29fb";
const BRAND_DARK = "#5a1dc4";
const DONE = "#a9a4b8";

const toDataUri = svg =>
  `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Purple disc with a white top-down car and a pulsing halo (live signal)
export const CAB_ICON_SIZE = 56;
export const cabIcon = () => {
  const pulse = prefersReducedMotion()
    ? ""
    : `<animate attributeName="r" values="15;26;15" dur="2.4s" repeatCount="indefinite"/>
       <animate attributeName="opacity" values="0.35;0;0.35" dur="2.4s" repeatCount="indefinite"/>`;
  return toDataUri(
    `<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
      <circle cx="28" cy="28" r="15" fill="${BRAND}" opacity="0.35">${pulse}</circle>
      <circle cx="28" cy="28" r="15" fill="${BRAND}" stroke="#fff" stroke-width="3"/>
      <rect x="21.5" y="18.5" width="13" height="19" rx="4.5" fill="#fff"/>
      <rect x="23.5" y="21.5" width="9" height="4" rx="1.2" fill="${BRAND}"/>
      <rect x="23.5" y="31" width="9" height="3" rx="1" fill="${BRAND}"/>
    </svg>`
  );
};

const PIN_PATH =
  "M17 1C8.2 1 1 8 1 16.6c0 11.2 14.2 25 15 25.8a1.4 1.4 0 0 0 2 0C18.8 41.6 33 27.8 33 16.6 33 8 25.8 1 17 1z";

// state: "next" (the stop the cab is heading to or at) | "upcoming" | "done"
// numbered: the number is drawn by the marker label, so leave the pin empty
export const STOP_ICON_SIZE = { width: 34, height: 44 };
export const stopPinIcon = (state, numbered) => {
  const fill = state === "next" ? BRAND : state === "done" ? DONE : "#fff";
  const stroke = state === "upcoming" ? BRAND : "#fff";
  let inner = "";
  if (!numbered) {
    inner =
      state === "done"
        ? `<path d="M11.5 16.5l4 4 7-8" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>`
        : `<circle cx="17" cy="16.5" r="5.5" fill="${
            state === "next" ? "#fff" : BRAND
          }"/>`;
  }
  return toDataUri(
    `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="44" viewBox="0 0 34 44">
      <path d="${PIN_PATH}" fill="${fill}" stroke="${stroke}" stroke-width="2"/>
      ${inner}
    </svg>`
  );
};

export const stopLabelColor = state =>
  state === "upcoming" ? BRAND_DARK : "#fff";
